import { BillingOffersObject } from 'src/app/models/orders/order-details-billing/billing-offers/billing-offers-object.model';

export class BillingInventoryResponse {

    constructor(private billingDate: string, private offersList: Array<BillingOffersObject>) {
    }

    public getOffersList(): Array<BillingOffersObject> {
        return this.offersList;
    }

    public getBillingDate(): string {
        return this.billingDate;
    }
}



